import * as types from '../actionTypes';

const initialState = {
  headers: [],
  loading: false,
  error: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_HEADER_REQUEST:
      return {...state, loading: true, error: null};
    case types.FETCH_HEADER_SUCCESS:
      return {...state, loading: false, headers: action.headers, error: null};
    case types.FETCH_HEADER_FAILURE:
      return {...state, loading: false, error: action.error};
    default:
      return {...state};
  }
};

export default reducer;